import { IconButton } from '@hover/blueprint';
import type { IconButtonProps } from '@hover/blueprint/chakra';
import { iconEllipsis } from '@hover/icons';
import React from 'react';

const ExpandButton = ({ ...props }: Pick<IconButtonProps, 'onClick'>) => (
  <IconButton
    shape="circle"
    variant="secondary"
    {...props}
    icon={iconEllipsis}
    label="..."
    testId="expand-button"
  />
);

export { ExpandButton };
